import api from './api'

const contractService = {
  getContracts: (filters: any) => api.get('/contratos', { params: filters }),
  getContractById: (id: number) => api.get(`/contratos/${id}`),
  getNextContractNumber: () => api.get('/contratos/next-number'),
  createContract: (data: any) => api.post('/contratos', data),
  updateContract: (id: number, data: any) => api.put(`/contratos/${id}`, data),
  finalizeContract: (id: number) => api.put(`/contratos/${id}/finalizar`),
  handoverProperty: (id: number, data: { fecha_entrega: string; notas?: string }) =>
    api.post(`/contratos/${id}/handover`, data),
  sendToLegal: (id: number, data: { fecha_ingreso?: string; notas: string }) =>
    api.post(`/contratos/${id}/send-to-legal`, data),
  getCancellationBalances: (id: number) =>
    api.get(`/contratos/${id}/cancellation-balances`),
  cancelContract: (id: number, data: { fecha_cancelacion: string }) =>
    api.post(`/contratos/${id}/cancel`, data),
  updateDiaPago: (id: number, data: { dia_pago: number; propagate?: boolean }) =>
    api.put(`/contratos/${id}/dia-pago`, data),
  getRecibosByContract: (id: number) => api.get(`/contratos/${id}/recibos`),
  transferContract: (id: number, data: { new_tenant_id: number; transfer_date: string }) =>
    api.post(`/contratos/${id}/transfer`, data),
  getGarantias: () => api.get('/garantias'),
  getGarantiaById: (id: number) => api.get(`/garantias/${id}`),
  createGarantia: (data: { nombre: string; descripcion?: string | null }) =>
    api.post('/garantias', data),
  updateGarantia: (id: number, data: { nombre?: string; descripcion?: string | null }) =>
    api.put(`/garantias/${id}`, data),
  deleteGarantia: (id: number) => api.delete(`/garantias/${id}`),
}

export default contractService


